import { render } from "./DashboardOfferMap.vue?vue&type=template&id=775c9e5e&scoped=true"
import script from "./DashboardOfferMap.vue?vue&type=script&lang=ts"
export * from "./DashboardOfferMap.vue?vue&type=script&lang=ts"

import "./DashboardOfferMap.vue?vue&type=style&index=0&id=775c9e5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-775c9e5e"

export default script